/**
 * @type {RegExp}
 */
const checkHEX = /^#?([0-9A-F]{3}|[0-9A-F]{6})$/i;

/**
 * @private
 * @type {RegExp}
 */
const checkRGB = /^rgb\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*\)$/i;

/**
 * @private
 * @type {RegExp}
 */
const checkRGBA = /^rgba\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9.]+)\s*\)$/i;

/**
 * @private
 * @type {RegExp}
 */
const checkHSLA = /^hsla\(\s*([0-9]{1,3})\s*,\s*([0-9.]+)%\s*,\s*([0-9.]+)%\s*,\s*([0-9.]+)\s*\)$/i;

/**
 * @private
 * @type {RegExp}
 */
const checkHSL = /^hsl\(\s*([0-9]{1,3})\s*,\s*([0-9.]+)%\s*,\s*([0-9.]+)%\s*\)$/i;

/**
 * List of CSS color names
 *
 * @private
 * @type {Object}
 */
const cssColors = {
	'aliceblue': 0xf0f8ff,
	'antiquewhite': 0xfaebd7,
	'aqua': 0x00ffff,
	'aquamarine': 0x7fffd4,
	'azure': 0xf0ffff,
	'beige': 0xf5f5dc,
	'bisque': 0xffe4c4,
	'black': 0x000000,
	'blanchedalmond': 0xffebcd,
	'blue': 0x0000ff,
	'blueviolet': 0x8a2be2,
	'brown': 0xa52a2a,
	'burlywood': 0xdeb887,
	'cadetblue': 0x5f9ea0,
	'chartreuse': 0x7fff00,
	'chocolate': 0xd2691e,
	'coral': 0xff7f50,
	'cornflowerblue': 0x6495ed,
	'cornsilk': 0xfff8dc,
	'crimson': 0xdc143c,
	'cyan': 0x00ffff,
	'darkblue': 0x00008b,
	'darkcyan': 0x008b8b,
	'darkgoldenrod': 0xb8860b,
	'darkgray': 0xa9a9a9,
	'darkgreen': 0x006400,
	'darkgrey': 0xa9a9a9,
	'darkkhaki': 0xbdb76b,
	'darkmagenta': 0x8b008b,
	'darkolivegreen': 0x556b2f,
	'darkorange': 0xff8c00,
	'darkorchid': 0x9932cc,
	'darkred': 0x8b0000,
	'darksalmon': 0xe9967a,
	'darkseagreen': 0x8fbc8f,
	'darkslateblue': 0x483d8b,
	'darkslategray': 0x2f4f4f,
	'darkslategrey': 0x2f4f4f,
	'darkturquoise': 0x00ced1,
	'darkviolet': 0x9400d3,
	'deeppink': 0xff1493,
	'deepskyblue': 0x00bfff,
	'dimgray': 0x696969,
	'dimgrey': 0x696969,
	'dodgerblue': 0x1e90ff,
	'firebrick': 0xb22222,
	'floralwhite': 0xfffaf0,
	'forestgreen': 0x228b22,
	'fuchsia': 0xff00ff,
	'gainsboro': 0xdcdcdc,
	'ghostwhite': 0xf8f8ff,
	'gold': 0xffd700,
	'goldenrod': 0xdaa520,
	'gray': 0x808080,
	'green': 0x008000,
	'greenyellow': 0xadff2f,
	'grey': 0x808080,
	'honeydew': 0xf0fff0,
	'hotpink': 0xff69b4,
	'indianred': 0xcd5c5c,
	'indigo': 0x4b0082,
	'ivory': 0xfffff0,
	'khaki': 0xf0e68c,
	'lavender': 0xe6e6fa,
	'lavenderblush': 0xfff0f5,
	'lawngreen': 0x7cfc00,
	'lemonchiffon': 0xfffacd,
	'lightblue': 0xadd8e6,
	'lightcoral': 0xf08080,
	'lightcyan': 0xe0ffff,
	'lightgoldenrodyellow': 0xfafad2,
	'lightgray': 0xd3d3d3,
	'lightgreen': 0x90ee90,
	'lightgrey': 0xd3d3d3,
	'lightpink': 0xffb6c1,
	'lightsalmon': 0xffa07a,
	'lightseagreen': 0x20b2aa,
	'lightskyblue': 0x87cefa,
	'lightslategray': 0x778899,
	'lightslategrey': 0x778899,
	'lightsteelblue': 0xb0c4de,
	'lightyellow': 0xffffe0,
	'lime': 0x00ff00,
	'limegreen': 0x32cd32,
	'linen': 0xfaf0e6,
	'magenta': 0xff00ff,
	'maroon': 0x800000,
	'mediumaquamarine': 0x66cdaa,
	'mediumblue': 0x0000cd,
	'mediumorchid': 0xba55d3,
	'mediumpurple': 0x9370db,
	'mediumseagreen': 0x3cb371,
	'mediumslateblue': 0x7b68ee,
	'mediumspringgreen': 0x00fa9a,
	'mediumturquoise': 0x48d1cc,
	'mediumvioletred': 0xc71585,
	'midnightblue': 0x191970,
	'mintcream': 0xf5fffa,
	'mistyrose': 0xffe4e1,
	'moccasin': 0xffe4b5,
	'navajowhite': 0xffdead,
	'navy': 0x000080,
	'oldlace': 0xfdf5e6,
	'olive': 0x808000,
	'olivedrab': 0x6b8e23,
	'orange': 0xffa500,
	'orangered': 0xff4500,
	'orchid': 0xda70d6,
	'palegoldenrod': 0xeee8aa,
	'palegreen': 0x98fb98,
	'paleturquoise': 0xafeeee,
	'palevioletred': 0xdb7093,
	'papayawhip': 0xffefd5,
	'peachpuff': 0xffdab9,
	'peru': 0xcd853f,
	'pink': 0xffc0cb,
	'plum': 0xdda0dd,
	'powderblue': 0xb0e0e6,
	'purple': 0x800080,
	'rebeccapurple': 0x663399,
	'red': 0xff0000,
	'rosybrown': 0xbc8f8f,
	'royalblue': 0x4169e1,
	'saddlebrown': 0x8b4513,
	'salmon': 0xfa8072,
	'sandybrown': 0xf4a460,
	'seagreen': 0x2e8b57,
	'seashell': 0xfff5ee,
	'sienna': 0xa0522d,
	'silver': 0xc0c0c0,
	'skyblue': 0x87ceeb,
	'slateblue': 0x6a5acd,
	'slategray': 0x708090,
	'slategrey': 0x708090,
	'snow': 0xfffafa,
	'springgreen': 0x00ff7f,
	'steelblue': 0x4682b4,
	'tan': 0xd2b48c,
	'teal': 0x008080,
	'thistle': 0xd8bfd8,
	'tomato': 0xff6347,
	'turquoise': 0x40e0d0,
	'violet': 0xee82ee,
	'wheat': 0xf5deb3,
	'white': 0xffffff,
	'whitesmoke': 0xf5f5f5,
	'yellow': 0xffff00,
	'yellowgreen': 0x9acd32
};

/**
 * Render Color
 */
export default class Color {
	/**
	 * Class constructor
	 *
	 * @param {number} [red]
	 * @param {number} [green]
	 * @param {number} [blue]
	 * @param {number} [alpha]
	 */
	constructor(red = 0, green = 0, blue = 0, alpha = 255) {
		/**
		 * Color values
		 *
		 * @type {Array}
		 */
		this.values = [red, green, blue, alpha];

		/**
		 * Red channel value
		 *
		 * @type {number}
		 */
		this.r = red;

		/**
		 * Green channel value
		 *
		 * @type {number}
		 */
		this.g = green;

		/**
		 * Blue channel value
		 *
		 * @type {number}
		 */
		this.b = blue;

		/**
		 * @type {number}
		 */
		this.rgb = (red << 16) | (green << 8) | blue;

		/**
		 * CSS RGB value: rgb(r, g, b)
		 *
		 * @type {string}
		 */
		this.rgbCss = 'rgb(' + red + ',' + green + ',' + blue + ')';

		/**
		 * @type {number}
		 */
		this.rgba = (this.rgb << 8) | alpha;

		/**
		 * @type {number}
		 */
		this.alphaNormal = alpha / 255;

		/**
		 * CSS RGBA value: rgb(r, g, b, a)
		 *
		 * @type {string}
		 */
		this.rgbaCss = 'rgba(' + red  + ',' + green + ',' + blue + ',' + this.alphaNormal + ')';

		/**
		 * @type {number}
		 */
		this.alpha = alpha;
	}

	/**
	 * Creates instance of the color from decimal value, HEX, RGBA or color name (white, green ...)
	 *
	 * @param {(string|number)} value
	 * @param {number} [alpha]
	 * @returns {Color}
	 */
	static create(value, alpha) {
		let match, r = null, g, b;

		alpha = typeof(alpha) !== 'number' ? 255 : (alpha > 255 ? 255 : (alpha < 0 ? 0 : alpha));

		if (typeof value === 'string') {
			if (value === 'transparent') {
				value = 0x0;
				alpha = 0;
			} else if (cssColors[value]) {
				// get decimal by color name
				value = cssColors[value];
			} else if (null !== (match = value.match(checkHEX))) {
				// hex
				value = match[1];
				if (value.length === 3) {
					value = parseInt(value + value, 16);
				} else {
					value = parseInt(value + value, 16);
				}
			} else if (null !== (match = value.match(checkRGBA))) {
				r = parseInt(match[1], 10);
				g = parseInt(match[2], 10);
				b = parseInt(match[3], 10);
				alpha = (parseFloat(match[4]) * 0xff) & 0xff;
			} else if (null !== (match = value.match(checkRGB))) {
				r = parseInt(match[1], 10);
				g = parseInt(match[2], 10);
				b = parseInt(match[3], 10);
			} else if (null !== (match = value.match(checkHSLA))) {
				let h = parseFloat(match[1]),
					s = parseFloat(match[2]) / 100,
					l = parseFloat(match[3]) / 100;
				alpha = (parseFloat(match[4]) * 0xff) & 0xff;
				return new Color(0, 0, 0, alpha).setHSL(h, s, l);
			} else if (null !== (match = value.match(checkHSL))) {
				let h = parseFloat(match[1]),
					s = parseFloat(match[2]) / 100,
					l = parseFloat(match[3]) / 100;
				return new Color().setHSL(h, s, l);
			} else {
				value = Number(value);
			}
		} else if (Array.isArray(value) && value.length >= 3) {
			r = Number(value[0]) || 0;
			g = Number(value[1]) || 0;
			b = Number(value[2]) || 0;
		} else if (typeof value !== 'number') {
			throw new Error('Invalid type of color value specified');
		}
		if (r === null) {
			r = (value >>> 16) & 0xFF;
			g = (value >>> 8) & 0xFF;
			b = value & 0xFF;
		}
		return new Color(r, g, b, alpha);
	}

	/**
	 * Sets alpha channel value
	 *
	 * @param {number} alpha From 0 to 255
	 * @returns {Color}
	 */
	setAlpha(alpha) {
		this.alpha = Math.min(255, Math.max(0, alpha));
		this.alphaNormal = this.alpha / 255;
		this.values[3] = this.alpha;
		this.rgba = (this.rgb << 8) | this.alpha;
		this.rgbaCss = 'rgba(' + this.r  + ',' + this.g + ',' + this.b + ',' + this.alphaNormal + ')';
		return this;
	}

	/**
	 * Sets RGB color parameters
	 *
	 * @param {number} r
	 * @param {number} g
	 * @param {number} b
	 * @returns {Color}
	 */
	setRGB(r, g, b) {
		this.values[0] = this.r = r & 0xFF;
		this.values[1] = this.g = g & 0xFF;
		this.values[2] = this.b = b & 0xFF;
		this.rgb = (this.r << 16) | (this.g << 8) | this.b;
		this.rgba = (this.rgb << 8) | this.alpha;
		this.rgbCss = 'rgb(' + this.r + ',' + this.g + ',' + this.b + ')';
		this.rgbaCss = 'rgba(' + this.r  + ',' + this.g + ',' + this.b + ',' + this.alphaNormal + ')';
		return this;
	}

	/**
	 * Returns HSL (Hue, Saturation, Lightness) parameters of the color
	 *
	 * @returns {Array<number>}
	 */
	getHSL() {
		let r = this.r / 255,
			g = this.g / 255,
			b = this.b / 255,
			min = Math.min(r, g, b),
			max = Math.max(r, g, b),
			diff = max - min,
			h = 0, s = 0, l = (min + max) / 2;

		if (diff !== 0) {
			s = l < 0.5 ? diff / (max + min) : diff / (2 - max - min);
			if (r === max) {
				h = (g - b) / diff;
			} else if (g === max) {
				h = 2 + (b - r) / diff;
			} else {
				h = 4 + (r - g) / diff;
			}
			h *= 60;
		}
		while (h < 0) {
			h += 360;
		}
		h %= 360;
		return [h, s, l];
	}

	setHSL(h, s, l) {
		h = Math.max(0, Math.min(360, h));
		l = Math.max(0, Math.min(1, l));
		s = Math.max(0, Math.min(1, s));
		if (s === 0) {
			this.setRGB(l * 255, l * 255, l * 255);
			return this;
		}
		let temp2 = l < 0.5 ? l * (1 + s) : l + s - l * s,
			temp1 = 2 * l - temp2;
		h /= 360;
		let rgb = [(h + 1 / 3) % 1, h, (h + 2 / 3) % 1],
			i = 0;
		for (; i < 3; ++i) {
			rgb[i] = rgb[i] < 1 / 6 ? temp1 + (temp2 - temp1) * 6 * rgb[i] : rgb[i] < 1 / 2 ? temp2 : rgb[i] < 2 / 3 ? temp1 + (temp2 - temp1) * 6 * (2 / 3 - rgb[i]) : temp1;
		}
		this.setRGB(Math.round(rgb[0] * 255), Math.round(rgb[1] * 255), Math.round(rgb[2] * 255));
		return this;
	}

	/**
	 * Sets color from HSV (Hue, Saturation, Value (Brightness)) parameters
	 *
	 * @param {number} h
	 * @param {number} s
	 * @param {number} v
	 * @returns {Color}
	 */
	setHSV(h, s, v) {
		let l = v * (1 - s / 2);
		if (l < 0.0001 || l > 0.998) {
			s = 0;
		} else {
			s = (v - l) / Math.min(l, 1 - l);
		}
		this.setHSL(h, s, l);
		return this;
	}
}
